import type { RoleAssignment, User } from "@/types";
import { UserRole } from "@/types";
import { isAdminOrSuperAdmin } from "./isSuperAdmin";

/** Miroir client de l'audience de `get_shared_official_link_notices` :
 *  `officials_caller_is_privileged()` (is_admin() OU super_admin) OU un rôle
 *  `league_president` (la RPC ne renvoie des lignes qu'aux ligues présidées).
 *  Coordinateurs, comptables, planificateurs ne reçoivent rien : la source ne
 *  tourne pas pour eux et ne leur fait pas apparaître la cloche.
 *
 *  Même normalisation que `canManageLeague` : les assignations exposées font foi,
 *  `role` / `primaryRole` ne servent que s'il n'y en a aucune. */
export function canSeeOfficialLinkNotices(user: User | null | undefined): boolean {
  if (!user) return false;
  if (isAdminOrSuperAdmin(user)) return true;
  const assignments: RoleAssignment[] = user.roles?.length
    ? user.roles
    : [{ role: user.primaryRole || user.role, leagueIds: user.leagueIds }];
  return assignments.some((a) => a.role === UserRole.LEAGUE_PRESIDENT);
}
